import AllInOneHelpWidget, { AllInOneHelpWidgetInstance } from "derbysoft-all-in-one-help-widget";
import { useEffect } from "react";
import {
    Route,
    Redirect,
  } from "react-router-dom";

import  allInOneHelpWidget from '../../src/components/ui/Widget/index'

interface propTypes {
    children?: React.ReactNode,
    key: any,
    path: string,
    statusSession: any,
    exact : boolean,
    layout: React.ElementType<any>,
    component: React.ElementType<any>,
}

const PrivateRoute = (props: propTypes ) => {

    const {layout : Layout, component: Component, statusSession} = props
    const allinOne: AllInOneHelpWidget = allInOneHelpWidget
    
    useEffect (()=>{
        allinOne.render()
    },[])
    


    if (statusSession.loggedIn) {
        return (
            <Route exact={props.exact} path={props.path}>
                    <Layout>
                        <Component/>
                    </Layout>
            </Route>
        )
    } else {
        return <Redirect to={{ pathname: "/login" }} />
    }
}

export default PrivateRoute